import React, { useContext } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { MyContext } from "@/store/myContext";
import { AddWarehouseDrawer } from "./AddWarehouseDrawer";

export default () => {
    const { state } = useContext(MyContext);

    return (
        <>
            {state.activeMenu === "baseWarehouse" && <>
                <PageHeader />
                <DataBox />
                <AddWarehouseDrawer />
            </>}
        </>
    )
}